import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { currentTransState } from '../../../atoms';
import {
	addGiftCard,
	clearGiftCardSelection,
	removeGiftCard
} from '../../../domains/Checkout/slice';
import { Flex } from '../../../GlobalComponents/Flex';
import { useAppDispatch, useAppSelector } from '../../../reduxstore/hooks';
import { CardRow } from '../CardRow';

const GiftCardPayment: React.FC = () => {
	const dispatch = useAppDispatch();

	const currentTrans = useRecoilValue(currentTransState);
	const balanceDue = useAppSelector(
		state => +state.checkoutReducer.balanceDue
	);

	const addedCards = useAppSelector(
		state => state.checkoutReducer.giftCardPayments
	);

	const availableCards = useAppSelector(state =>
		[...(state.accountReducer.profile.cards || [])].sort((a, b) => {
			// Check if one of the cards is the default payment method
			if (a.default_payment_method && !b.default_payment_method) {
				return -1; // a comes first
			}
			if (!a.default_payment_method && b.default_payment_method) {
				return 1; // b comes first
			}

			return Number(b.cash) - Number(a.cash); // Sort by amount in descending order
		})
	);

	const isCardSelected = (cardNumber: number) =>
		addedCards.some(addedCard => addedCard.cardNumber === `${cardNumber}`);

	const handleCardSelect = (card: Card) => {
		const cardExists = addedCards.some(
			addedCard => addedCard.cardNumber === `${card.card_number}`
		);
		if (cardExists) {
			dispatch(removeGiftCard(card.card_number));
		} else {
			dispatch(addGiftCard(card));
		}
	};

	useEffect(() => {
		dispatch(clearGiftCardSelection(Number(currentTrans?.total) || 0));
	}, [currentTrans?.total, dispatch]);

	return (
		<Flex $flexDirection="column" $rowGap="5px">
			{availableCards.map(card => (
				<CardRow
					key={card.card_number}
					card={card}
					showAddBalance={
						Number(currentTrans?.total) > card.cash ? true : false
					}
					isSelected={isCardSelected(card.card_number)}
					balanceDue={balanceDue}
					onSelect={() =>
						balanceDue > 0 || isCardSelected(card.card_number)
							? handleCardSelect(card)
							: undefined
					}
				/>
			))}
		</Flex>
	);
};

export default GiftCardPayment;
